document.addEventListener("DOMContentLoaded", function () {
    let benefitsCardsList = document.querySelectorAll('.benefits-card-row');
    benefitsCardsList.forEach(function(benefitsCards) {
        let Children = benefitsCards.querySelectorAll('.benefits-card').length;

        if (Children == 4) {
            benefitsCards.classList.add('card-row-small');
        }
        if (Children == 3) {
            benefitsCards.classList.add('card-row-medium');
        }
        if (Children == 2) {
            benefitsCards.classList.add('card-row-large');
        }
    });

    $(".benefits-cards img").css({
        "max-width": "100%",
        "height": "auto",
        "loading": "lazy",
        "display":"block",
    });
});